import { render, staticRenderFns } from "./TemperaturasView.vue?vue&type=template&id=6814e18e&scoped=true"
import script from "./TemperaturasView.vue?vue&type=script&lang=js"
export * from "./TemperaturasView.vue?vue&type=script&lang=js"
import style0 from "./TemperaturasView.vue?vue&type=style&index=0&id=6814e18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6814e18e",
  null
  
)

export default component.exports